import { render } from "./TrainerList.vue?vue&type=template&id=cb060c42&scoped=true"
import script from "./TrainerList.vue?vue&type=script&lang=ts"
export * from "./TrainerList.vue?vue&type=script&lang=ts"

import "./TrainerList.vue?vue&type=style&index=0&id=cb060c42&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cb060c42"

export default script